import { render, staticRenderFns } from "./stylePage.vue?vue&type=template&id=65430dc8&scoped=true&"
import script from "./stylePage.vue?vue&type=script&lang=js&"
export * from "./stylePage.vue?vue&type=script&lang=js&"
import style0 from "./stylePage.vue?vue&type=style&index=0&id=65430dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65430dc8",
  null
  
)

export default component.exports